export const headingStyles = {
  components: {
    Heading: {
      defaultProps: {
        size: "md",
      },
    },
  },
};
